import { render, staticRenderFns } from "./ManagerAddForm.vue?vue&type=template&id=36f88504&scoped=true&"
import script from "./ManagerAddForm.vue?vue&type=script&lang=js&"
export * from "./ManagerAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f88504",
  null
  
)

export default component.exports